import React, { useState } from 'react'
import AddOrder from '../../orders/tabItems/AddOrder'
import ClassicInventoryList from './ClassicInventoryList'
import dayjs from 'dayjs';
import { App, Button, Form, Input, InputNumber, Select, Tag } from 'antd';
import ClassicShoppingCart from './ClassicShoppingCart';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, clearCart, setDiscount, setShipping } from '../../../store/slices/cartSlice';
import { GET, POST } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher, processReq } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { getNetTotal } from '../../../utils/formatters';
import PrintableInvoice from '../../../components/PrintableInvoice';

function AddOrderView() {
    const { message } = App.useApp();
    const [selectedProduct, setSelectedProduct] = useState({});
    const dispatch = useDispatch();
    const dataFetcher = useSWR({ method: GET, url: API_ROUTE + '/users' }, fetcher);
    const users = dataFetcher.isLoading ? [] : dataFetcher.data.data;
    const [serialNumbers, setSerialNumbers] = useState('');
    const [warrantyPeriod, setWarrantyPeriod] = useState('');
    const [customerUserId, setCustomerUserId] = useState(null);
    const [customerName, setCustomerName] = useState('');
    const [customerMobileNumber, setCustomerMobileNumber] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');
    const cart = useSelector(state => state.cartSlice);
    const shippingFee = useSelector((state) => state.settingsSlice.settings.defaultShippingFee);
    const [isLoading, setIsLoading] = useState(false);
    const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [invoiceSize, setInvoiceSize] = useState(false);
    const order = useSelector(state => state.orderSlice.order);

    const onAddProduct = () => {
        if (selectedProduct.id) {
            onAddToOrder(selectedProduct);
        } else {
            message.error("Please select a product first")
        }
    }

    const onAddToOrder = (item) => {
        dispatch(addToCart({ productId: item.productId, quantity: item.quantity || 1, price: item.price, product: item.product, inventory: item }));
    }

    const saveOrder = async () => {
        if (order.id) {
            // dispatch(updateOrder({ orderId: order.id, orderData: cleanData }));
        } else {
            try {
                setIsLoading(true);

                const shipping = {
                    address: customerAddress,
                    // zip: formData.zip,
                    // city: formData.city,
                    // country: formData.country,
                    firstName: customerName,
                    lastName: customerName,
                    email: customerEmail,
                    telephone: customerMobileNumber
                }

                dispatch(setShipping(shipping));

                const orderResponse = await processReq(POST, API_ROUTE + '/orders/create/admin', {
                    cartItems: cart.cartItems,
                    total: getNetTotal(cart.total, shippingFee, cart.totalDiscount),
                    shipping: shipping,
                    paymentMethod: cart.paymentMethod,
                    userId: customerUserId,
                    discount: cart.discount
                });

                if (orderResponse?.order?.id) {
                    // if (cart.paymentMethod === 'COD') {
                    dispatch(clearCart());

                    message.success("We've created an order for you. Your tracking number is " + orderResponse?.order?.orderTrackingNumber)
                    // onSwitchTab(orderTabConfig.LIST);
                    // }
                }
            } catch (error) {
                console.log(error)
                message.error(error.message)
            } finally {
                setIsLoading(false);
            }
        }
    }

    const getInvoice = (size) => {
        setIsInvoiceModalOpen(true);
        setInvoiceSize(size);
        setInvoiceData({
            orderItems: cart.cartItems,
            shipping: {
                address: customerAddress,
                firstName: customerName,
                lastName: customerName,
                email: customerEmail,
                telephone: customerMobileNumber
            },
            email: customerEmail,
            orderDate: dayjs().format('YYYY-MM-DD'),
            customerName: customerName,
            id: dayjs().format('YYYYMMDD'),
            total: getNetTotal(cart.total, shippingFee, cart.totalDiscount),
            discount: cart.discount,
            totalDiscount: cart.totalDiscount,
            status: "New",
            orderTrackingNumber: null,
            createdAt: dayjs().format('YYYYMMDD'),

        })
    }


    return (
        <div>
            <div className="grid grid-cols-2 gap-4">
                {selectedProduct.id ? (
                    <div>
                        <div className='grid grid-cols-2 gap-3 pt-4'>
                            <div>Date: {dayjs().format('YYYY-MM-DD')}</div>
                            <div>Name: {selectedProduct.product?.name}</div>
                            <div>Cost Price: {selectedProduct?.costPrice}</div>
                            <div>Discount: {selectedProduct?.discount}</div>
                            <div>Selling Price: {selectedProduct?.price}</div>

                            <div className='pb-1'>Warranty Period: <Input value={warrantyPeriod} onChange={(event) => setWarrantyPeriod(event.target.value)} placeholder="Enter Warranty Period" /></div>
                            <div className='pb-1'>If an existing customer, select here:
                                <Select
                                    placeholder="Select Customer"
                                    showSearch
                                    className='w-full'
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={users.map(user => ({ value: user.id, label: `${user.name} - ${user.email}` }))}
                                    onChange={(_, value) => setCustomerName(value.label)}
                                />
                            </div>
                            <div className='pb-1'>Customer: <Input value={customerName} onChange={(event) => setCustomerName(event.target.value)} placeholder="Enter Customer Name" /></div>
                            <div className='pb-1'>Serial Numbers:
                                <div className='pb-2'>{serialNumbers.split(',').map((data, index) => <Tag key={index}>{data}</Tag>)}</div>
                                <Input.TextArea className='w-full' value={serialNumbers} placeholder="Add Serial Numbers Here (Seperate with comma)" onChange={(event) => setSerialNumbers(event.target.value)} />
                            </div>
                        </div>
                        <div className='text-right pt-4'><Button onClick={onAddProduct} size='large'>ADD</Button></div>
                    </div>
                ) : <div className="p-4 flex justify-center items-center"><div className='text-2xl text-slate-500'>Please select a product to add to invoice</div></div>}

                <div className="p-4 border-l">
                    <ClassicInventoryList
                        setSelectedProduct={setSelectedProduct}
                        selectedProduct={selectedProduct}
                        onAddToOrder={onAddToOrder}
                    />

                    <div className='grid grid-cols-2 gap-4 border-t mt-4'>
                        <div className='py-2'>
                            <div>Discount: <InputNumber className='w-full' placeholder="Add Discount Here" onChange={(value) => dispatch(setDiscount(value))} /></div>
                        </div>
                    </div>
                    <div>
                        <Button onClick={() => getInvoice('A5')}>Invoice (A5)</Button>
                        <Button onClick={() => getInvoice('A4')}>Invoice (A4)</Button>
                        <Button onClick={saveOrder}>Place Order</Button>
                    </div>

                </div>
            </div>
            <div className='border-t'> <ClassicShoppingCart /> </div>
            <PrintableInvoice order={invoiceData} isShow={isInvoiceModalOpen} setIsShow={setIsInvoiceModalOpen} invoiceSize={invoiceSize} />
        </div>
    )
}

export default AddOrderView